type WebViewWindow = Window & {
  ReactNativeWebView?: unknown;
};

export function isIosShell(): boolean {
  const params = new URLSearchParams(window.location.search);
  const source = params.get('source') ?? '';
  const platform = params.get('platform') ?? '';
  const w = window as WebViewWindow;
  const html = document.documentElement;
  return (
    html.classList.contains('ios-shell') ||
    platform === 'ios' ||
    source === 'ios' ||
    source.startsWith('ios-') ||
    typeof w.ReactNativeWebView !== 'undefined'
  );
}

export function isShortTouchLayout(): boolean {
  return window.matchMedia('(pointer: coarse) and (max-height: 500px)').matches;
}

export function isCompactTouchLayout(): boolean {
  return isIosShell() || isShortTouchLayout() || window.matchMedia('(max-width: 500px)').matches;
}
